import "./AllProjects.css";
import { PROJECTS } from "../../data";
import ProjectCard from "../project-card/ProjectCard";
import DetailsLayout from "../details-layout/DetailsLayout";

export default function AllProjects() {
  const renderProject = (project) => {
    return (
      <ProjectCard
        key={project.title}
        project={project}
        style={{
          maxWidth: "100vw",
        }}
      />
    );
  };

  return (
    <DetailsLayout subtitle={"All Projects"}>
      <div className="all-projects-container">
        {PROJECTS.map(renderProject)}
      </div>
    </DetailsLayout>
  );
}
